import { useNavigate } from 'react-router-dom';
import { Typography, Button, Card } from 'antd';

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Card style={{ width: 400, padding: 24, textAlign: 'center' }}>
        <Typography.Title level={3}>Access Denied</Typography.Title>
        <p>You don&apos;t have permission to access this page.</p>
        <Button type="primary" onClick={() => navigate('/dashboard')} style={{ marginTop: 16 }}>
          Back to Dashboard
        </Button>
      </Card>
    </div>
  );
} 